import WhatIsNew from './WhatIsNew'

export default WhatIsNew
